import { z } from "zod";
import { TObjectBase } from "../base";
import { TApiCRUDBy, TApiCrudByWithConverter, TCRUDBy } from "../common/CRUDBy";
import { TTranslationData } from "../common/translation";

export const TRawCompanyTag = z
  .object({
    badgeColor: z.string().optional(),
    badgeIcon: z.string().optional(),
    name: TTranslationData,
    description: z.string().optional(),
    id: z.string(),
    createdBy: TCRUDBy.optional(),
    updatedBy: TCRUDBy.optional(),
    deletedBy: TCRUDBy.optional(),
  })
  .extend(TObjectBase.shape);
export type IRawCompanyTag = z.infer<typeof TRawCompanyTag>;

export const TApiTag = z.object({
  badgeColor: z.string(),
  badgeIcon: z.string(),
  name: TTranslationData,
  description: z.string().optional(),
  id: z.string(),
  createdBy: TApiCRUDBy.optional(),
  updatedBy: TApiCRUDBy.optional(),
});
export type IApiTag = z.infer<typeof TApiTag>;

export const TApiTagConverter = TRawCompanyTag.extend({
  badgeColor: z.string().default("purple"),
  badgeIcon: z.string().default(""),
  createdBy: TApiCrudByWithConverter.optional(),
  deletedBy: TApiCrudByWithConverter.optional(),
  updatedBy: TApiCrudByWithConverter.optional(),
});
